import { useState } from 'react';

// Раскрывающийся алёрт «не заполнено планирование»: сводка от большего к меньшему.
// BU (N не заполнено) → ТМ (N) → СВ (N) → конкретный лист (маршрут/точка).
// roots: то же дерево, что и у сводной. leafId(node)=>id|null (лист). unplannedSet — Set id листьев без планирования.
export default function NoPlanTree({ roots, unplannedSet, onPick, leafId, unit = 'шт.' }) {
  const [open, setOpen] = useState({});
  const countUnder = (node) => {
    const id = leafId(node);
    if (id != null) return unplannedSet.has(id) ? 1 : 0;
    return (node.children || []).reduce((s, c) => s + countUnder(c), 0);
  };

  const render = (node, depth) => {
    const c = countUnder(node);
    if (!c) return [];
    const id = leafId(node);
    const isLeaf = id != null;
    const k = node.key;
    const rows = [];
    rows.push(
      <div key={k} onClick={() => isLeaf ? onPick(id) : setOpen(o => ({ ...o, [k]: !o[k] }))}
        style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '5px 8px', paddingLeft: 8 + depth * 14, cursor: 'pointer', borderBottom: '1px solid #F1E4C0', background: isLeaf ? '#fff' : '#FFFBEF' }}>
        {!isLeaf && <span style={{ fontSize: 9, color: '#8A6100', width: 8 }}>{open[k] ? '▼' : '▶'}</span>}
        <span style={{ flex: 1, minWidth: 0, fontSize: 11.5, color: '#6f5300', fontWeight: isLeaf ? 400 : 700, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {node.label}{node.sub ? <span style={{ color: '#b39760' }}> · {node.sub}</span> : ''}
        </span>
        <span style={{ fontSize: 11, fontWeight: 700, color: isLeaf ? '#b23' : '#8A6100', whiteSpace: 'nowrap' }}>
          {isLeaf ? 'перейти →' : `${c} ${unit}`}
        </span>
      </div>
    );
    if (!isLeaf && open[k]) (node.children || []).forEach(ch => rows.push(...render(ch, depth + 1)));
    return rows;
  };

  const total = roots.reduce((s, r) => s + countUnder(r), 0);
  return (
    <div style={{ border: '1px solid #F0C56A', borderRadius: 10, overflow: 'hidden', marginBottom: 12 }}>
      <div style={{ background: '#FFF3D6', padding: '8px 12px', fontSize: 12.5, fontWeight: 700, color: '#8A6100', borderBottom: '1px solid #F0C56A' }}>
        ⚠ Не проставлено планирование: {total} {unit} (нет плана на месяц или на текущую неделю, либо в табеле нет ни одного статуса: за месяц или за текущую неделю со вторника; вакансия и ОТ — это внесение) · раскрывайте от BU к маршруту
      </div>
      <div style={{ maxHeight: 320, overflowY: 'auto' }}>
        {roots.map(r => render(r, 0))}
      </div>
    </div>
  );
}
